import React, { useState } from 'react';
import { View, Text } from 'react-native'
import moment from 'moment';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './index';

const AssetsSoldSummary = () => {
  const [startOn, setStartOn] = useState(
    moment().subtract({ months: 1 }).format('YYYY-MM-DD')
  );

  const [endOn, setEndOn] = useState(
    moment().format('YYYY-MM-DD')
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'assets-sold-summary-report',
      params: { 'start-on': startOn, 'end-on': endOn }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Buyer/Seller Assets Sold Summary</Text>
      <Text style={styles.label}>Start On:</Text>
      <input
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
        type="date"
      />
      <Text style={styles.label}>End On:</Text>
      <input
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
        type="date"
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default AssetsSoldSummary;
